export const DEFAULT_AGENT_APPROVAL_PROFILE = 'fast';
export const INVALID_AGENT_APPROVAL_PROFILE_FALLBACK = 'careful';
export const AGENT_TOOL_APPROVAL_MODES = Object.freeze(['auto', 'confirm']);
export const AGENT_APPROVAL_PROFILE_VALUES = Object.freeze(['careful', 'fast']);
// The errorText a declined approval writes on its tool call. The client writes it and the
// Worker reads it from the transcript, so it lives here rather than in the client registry.
export const DECLINED_TOOL_MESSAGE = 'User declined tool execution.';

export const AGENT_APPROVAL_PROFILE_OPTIONS = Object.freeze([
  {
    value: 'careful',
    label: 'Careful',
    description: 'Keep confirm gates on broad, costly, or structural mutations.',
  },
  {
    value: 'fast',
    label: 'Fast',
    description: 'Auto-run low-risk organization actions while keeping high-impact tools gated.',
  },
]);

export function normalizeAgentApprovalProfile(
  value,
  fallback = INVALID_AGENT_APPROVAL_PROFILE_FALLBACK,
) {
  return AGENT_APPROVAL_PROFILE_VALUES.includes(value) ? value : fallback;
}

export default {
  DEFAULT_AGENT_APPROVAL_PROFILE,
  INVALID_AGENT_APPROVAL_PROFILE_FALLBACK,
  AGENT_TOOL_APPROVAL_MODES,
  AGENT_APPROVAL_PROFILE_VALUES,
  AGENT_APPROVAL_PROFILE_OPTIONS,
  DECLINED_TOOL_MESSAGE,
  normalizeAgentApprovalProfile,
};
